// extracted by mini-css-extract-plugin
export default {"amountInput":"AmountInput_amountInput__xeqLy"};